/*
  Love'nSpa - instrumentation du parcours de reservation

  Cadre RGPD, exemption de consentement CNIL pour la mesure d'audience :
  1. Finalite limitee a la mesure d'audience du site. Aucun recoupement avec un
     autre traitement, aucune transmission a un tiers.
  2. Identifiant de visite non persistant, stocke en sessionStorage. Pas de
     cookie, pas de localStorage, aucune reconstitution du parcours entre visites.
  3. Aucune adresse IP stockee, meme tronquee, et aucun user agent brut.

  ETAT DU FUNNEL au 11 septembre 2026 : le widget natif v2 a remplace l'iframe
  Bookingmood sur tout le parc le 8 septembre. Le calendrier est desormais du
  DOM de la page : assets/loven-booking.js emet lui-meme calendar_open,
  date_selected, no_availability, checkout_start, booking_created,
  booking_failed, form_error et widget_fallback. Ce fichier-ci ne mesure plus
  que ce qui est hors du widget.

  ── Ce que la bascule v2 a casse, et comment c'est repare ────────────────────
  widget_visible et widget_interact etaient tous deux calcules en cherchant une
  iframe dont le src contient bookingmood.com. En v2 cette iframe n'existe plus
  (elle ne subsiste que dans un <template> de repli), et les fiches en
  reservation externe n'en ont jamais eu. Les deux evenements sont donc restes
  a zero sur tout le parc entre le 08/09 et le 11/09 : un zero qui est une
  panne, pas une mesure.

   - widget_visible est reconstruit sur le conteneur .loven-dates, qui est rendu
     en Liquid dans les trois cas (v2, iframe de repli, reservation externe).
     Il porte desormais payload.variante pour distinguer les trois parcours.
   - widget_interact est ABANDONNE. C'etait une approximation par perte de focus
     et par redimensionnement d'iframe, sans equivalent en v2 et sans interet :
     calendar_open dit la meme chose en mieux, et il est emis par le widget
     lui-meme, qui sait ce que le visiteur a reellement fait.
     Ne pas le reintroduire. Les series historiques s'arretent au 08/09.
*/

(function () {
  'use strict';

  try {
    var config = window.LNS_FUNNEL || {};
    if (!config.endpoint) {
      return; // Rien a faire si le snippet Liquid n'a pas ete pose.
    }

    // ----------------------------------------------------------------
    // 1. Identifiant de visite
    // ----------------------------------------------------------------
    // Genere une chaine aleatoire, conservee le temps de l'onglet uniquement.
    function getSessionId() {
      var cle = 'lns_funnel_session';
      var valeur = null;
      try {
        valeur = window.sessionStorage.getItem(cle);
      } catch (e) {
        valeur = null;
      }
      if (!valeur) {
        valeur = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        try {
          window.sessionStorage.setItem(cle, valeur);
        } catch (e) {
          // Navigation privee ou stockage bloque : on garde la valeur en memoire.
        }
      }
      return valeur;
    }

    var sessionId = getSessionId();

    // ----------------------------------------------------------------
    // 1bis. Attribution publicitaire (test Meta Ads, 09/2026)
    // ----------------------------------------------------------------
    // Un clic Meta arrive sur une collection ou une fiche avec ?fbclid=...
    // puis le visiteur navigue : l'URL de la page ou il reserve n'a plus
    // rien. On memorise les parametres de la PREMIERE page de la visite
    // (sessionStorage, meme portee que session_id, pas de cookie) et on les
    // expose via LNS_FUNNEL.attribution(). RIEN ne part vers funnel-ingest :
    // ce tracker vit sous l'exemption CNIL de mesure d'audience (aucun
    // recoupement, aucun tiers) et un identifiant publicitaire n'y a pas sa
    // place — funnel-guards.ts ne conserverait d'ailleurs que des scalaires.
    // Seul loven-booking.js relit cette valeur pour la joindre a booking-create
    // (booking_attempts.attribution), ou la base contractuelle s'applique.
    // _fbp / _fbc sont les cookies poses par le pixel Meta (via GTM) quand
    // le consentement publicitaire est donne ; absents sinon, et c'est normal.
    var CLES_ATTRIBUTION = ['fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    function lireCookie(nom) {
      try {
        var m = document.cookie.match(new RegExp('(?:^|; )' + nom + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : null;
      } catch (e) { return null; }
    }

    function getAttribution() {
      var cle = 'lns_attribution';
      var memo = null;
      try { memo = JSON.parse(window.sessionStorage.getItem(cle) || 'null'); } catch (e) { memo = null; }
      if (!memo) {
        memo = {};
        var p = new URLSearchParams(window.location.search);
        CLES_ATTRIBUTION.forEach(function (k) { var v = p.get(k); if (v) memo[k] = v; });
        if (Object.keys(memo).length) {
          memo.landing_at = Date.now();
          memo.landing_path = window.location.pathname;
          try { window.sessionStorage.setItem(cle, JSON.stringify(memo)); } catch (e) { /* memoire seulement */ }
        }
      }
      return memo;
    }

    var attribution = getAttribution();

    function attributionCourante() {
      var out = {};
      for (var k in attribution) if (Object.prototype.hasOwnProperty.call(attribution, k)) out[k] = attribution[k];
      var fbp = lireCookie('_fbp'); if (fbp) out.fbp = fbp;
      var fbc = lireCookie('_fbc'); if (fbc) out.fbc = fbc;
      // fbc reconstruit si le pixel n'a pas pose le cookie (consentement refuse) :
      // meme format que Meta, utilisable par la Conversions API.
      if (!out.fbc && out.fbclid && out.landing_at) out.fbc = 'fb.1.' + out.landing_at + '.' + out.fbclid;
      // Consentement publicitaire AU MOMENT de la reservation (snippets/lns-attribution-lib).
      // Lovable n'envoie le gclid a Google Ads que si ad_user_data = granted.
      // Joint seulement quand un identifiant publicitaire existe : sans gclid ni
      // fbclid, il n'y a rien a conditionner.
      if ((out.gclid || out.fbclid) && window.LNS_ATTRIBUTION && typeof window.LNS_ATTRIBUTION.consentementPub === 'function') {
        out.consent = window.LNS_ATTRIBUTION.consentementPub(window.dataLayer);
      }
      return Object.keys(out).length ? out : null;
    }

    // ----------------------------------------------------------------
    // 2. Contexte de la visite, sans donnee personnelle
    // ----------------------------------------------------------------
    function detecterAppareil() {
      var largeur = window.innerWidth || document.documentElement.clientWidth || 0;
      if (largeur < 768) return 'mobile';
      if (largeur < 1024) return 'tablet';
      return 'desktop';
    }

    function domaineDe(url) {
      try {
        return new URL(url, window.location.href).hostname;
      } catch (e) {
        return null;
      }
    }

    var parametres = new URLSearchParams(window.location.search);

    // Canal d'arrivee, resolu une seule fois par snippets/lns-attribution-lib
    // et expose par datalayer-context. On le RECOPIE, on ne le recalcule pas :
    // deux calculs independants finiraient par diverger sur un cas limite, et
    // la divergence serait invisible.
    // Ces trois champs voyagent dans l'ENVELOPPE, pas dans le payload de
    // chaque evenement : ils decrivent la visite, pas l'evenement.
    var pageCtx = {};
    try {
      pageCtx = window.LNS_PAGE_CTX || {};
    } catch (e) {
      pageCtx = {};
    }

    var contexte = {
      session_id: sessionId,
      traffic_source: pageCtx.traffic_source || null,
      entry_list: pageCtx.entry_list || null,
      shopify_product_id: config.productId ? String(config.productId) : null,
      handle: config.handle || null,
      page_url: window.location.origin + window.location.pathname,
      referrer_host: pageCtx.referrer_host || (document.referrer ? domaineDe(document.referrer) : null),
      device: detecterAppareil(),
      utm_source: parametres.get('utm_source'),
      utm_medium: parametres.get('utm_medium'),
      utm_campaign: parametres.get('utm_campaign')
    };

    // ----------------------------------------------------------------
    // 3. File d'envoi, par paquets de 5 secondes
    // ----------------------------------------------------------------
    var file = [];
    var minuteur = null;
    // Evenements a envoyer une seule fois par visite. La cle de deduplication
    // est le couple type + source (payload.source), et non le type seul, pour
    // qu'un meme type puisse coexister sous deux provenances distinctes quand
    // l'arbitrage entre les deux a un interet analytique.
    var dejaEnvoyes = {};

    function corpsRequete(evenements) {
      var corps = {};
      for (var cle in contexte) {
        if (Object.prototype.hasOwnProperty.call(contexte, cle)) {
          corps[cle] = contexte[cle];
        }
      }
      corps.events = evenements;
      return JSON.stringify(corps);
    }

    function vider(utiliserBeacon) {
      if (!file.length) return;
      var lot = file.splice(0, file.length);
      var corps = corpsRequete(lot);

      // sendBeacon est obligatoire au dechargement de la page : un fetch
      // classique est annule des que la page part.
      //
      // Le type MIME n'est pas un detail. « application/json » ne fait pas
      // partie des types surs CORS : le navigateur exige alors un preflight
      // OPTIONS, que sendBeacon ne peut pas mener pendant le dechargement.
      // La requete est jetee en silence, et sendBeacon renvoie quand meme
      // true — qui ne dit que « mis en file », jamais « livre ».
      // Mesure du 15/09/2026, meme page, meme instant, meme corps :
      // text/plain arrive, application/json n'arrive jamais. C'est ce qui
      // rendait vedette_clic totalement invisible (0 evenement) et fiche_exit
      // quasi nul (13 contre 153 242 fiche_view).
      // « text/plain;charset=UTF-8 » est un type sur : requete simple, aucun
      // preflight. funnel-ingest lit le corps avec req.json(), qui ne regarde
      // pas le Content-Type.
      if (utiliserBeacon && navigator.sendBeacon) {
        try {
          var envoye = navigator.sendBeacon(
            config.endpoint,
            new Blob([corps], { type: 'text/plain;charset=UTF-8' })
          );
          // false = file du navigateur pleine, ou corps trop gros. Le lot a
          // deja ete retire de la file : sans ce repli, il serait perdu.
          if (envoye) return;
        } catch (e) {
          // On retombe sur fetch ci dessous.
        }
      }

      try {
        fetch(config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: corps,
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      } catch (e) {
        // Aucune erreur ne doit remonter a la page.
      }
    }

    function programmerEnvoi() {
      if (minuteur) return;
      minuteur = window.setTimeout(function () {
        minuteur = null;
        vider(false);
      }, 5000);
    }

    // immediat : vrai pour fiche_exit (et checkout_start si un jour actif).
    function envoyer(type, payload, options) {
      options = options || {};
      payload = payload || {};
      if (options.uneSeuleFois) {
        var cle = type + ':' + (payload.source || '');
        if (dejaEnvoyes[cle]) return;
        dejaEnvoyes[cle] = true;
      }
      file.push({
        event_type: type,
        occurred_at: new Date().toISOString(),
        payload: payload || {}
      });
      if (options.immediat) {
        if (minuteur) {
          window.clearTimeout(minuteur);
          minuteur = null;
        }
        vider(options.beacon === true);
      } else {
        programmerEnvoi();
      }
    }

    // ----------------------------------------------------------------
    // 3bis. Point d'entree du widget de reservation v2 (loven-booking.js)
    // ----------------------------------------------------------------
    // Le widget natif remplace l'iframe : il emet date_selected,
    // no_availability, checkout_start et les evenements suivants via
    // LNS_FUNNEL.track. Les evenements emis avant le chargement de ce
    // fichier attendent dans LNS_FUNNEL_QUEUE.
    config.track = function (type, payload, options) {
      envoyer(type, payload, options);
    };
    config.attribution = attributionCourante;
    try {
      var enAttente = window.LNS_FUNNEL_QUEUE || [];
      window.LNS_FUNNEL_QUEUE = [];
      enAttente.forEach(function (e) { envoyer(e[0], e[1], e[2]); });
    } catch (e) {
      // Une file corrompue ne doit jamais bloquer la mesure.
    }

    // ----------------------------------------------------------------
    // 4. Arrivee sur la fiche
    // ----------------------------------------------------------------
    var debutVisite = Date.now();
    // Certaines pages posent LNS_FUNNEL uniquement pour donner acces a track()
    // (page d'accueil : instrumentation du bloc « Love rooms a la Une »). Elles
    // n'ont pas de fiche : emettre fiche_view / fiche_exit y ferait entrer des
    // evenements sans shopify_product_id, en volume, dans les series du funnel.
    // Les pages de collection et de recherche ne sont PAS concernees : leur
    // comportement reste strictement inchange.
    var sansFiche = config.sansFiche === true;
    if (!sansFiche) {
      envoyer('fiche_view', {}, { uneSeuleFois: true });
    }

    // ----------------------------------------------------------------
    // 5. Le bloc de reservation entre dans le champ de vision
    // ----------------------------------------------------------------
    // On observe le conteneur .loven-dates, et non l'iframe Bookingmood.
    // C'est le seul element present dans les trois parcours : il est rendu en
    // Liquid par loven-booking (classe .loven-dates--v2), par le repli iframe
    // et par loven-book-external (classe .loven-dates--external). L'iframe,
    // elle, n'existe plus depuis la bascule v2 du 08/09/2026.
    //
    // Seuil a 0 avec une temporisation d'une seconde : le bloc mesure environ
    // 1 400 px de haut, ce qui depasse un viewport mobile, donc un seuil de
    // 50 pour cent serait inatteignable. La seconde d'attente ecarte les
    // scrolls rapides qui ne font que traverser la zone.
    //
    // Le conteneur est rendu cote serveur : il est dans le DOM des le parse.
    // Le widget v2 se monte dedans plus tard, sans jamais le remplacer, donc
    // aucune boucle de recherche n'est necessaire. Si le selecteur venait a
    // changer, l'evenement disparaitrait en silence : c'est ce qui s'est
    // produit avec l'iframe. La sonde de controle en fin de fichier sert
    // precisement a detecter ce cas.
    function trouverBlocReservation() {
      return document.querySelector('.loven-dates');
    }

    function varianteBloc(bloc) {
      if (!bloc) return 'inconnue';
      if (bloc.className.indexOf('loven-dates--external') !== -1) return 'external';
      if (bloc.querySelector('[data-loven-booking]')) return 'v2';
      return 'iframe';
    }

    var blocReservation = trouverBlocReservation();
    var attenteVisibilite = null;

    if (blocReservation && 'IntersectionObserver' in window) {
      var observateur = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) {
            if (!attenteVisibilite) {
              attenteVisibilite = window.setTimeout(function () {
                envoyer(
                  'widget_visible',
                  { variante: varianteBloc(blocReservation) },
                  { uneSeuleFois: true }
                );
                observateur.disconnect();
              }, 1000);
            }
          } else if (attenteVisibilite) {
            window.clearTimeout(attenteVisibilite);
            attenteVisibilite = null;
          }
        }
      }, { threshold: 0 });

      observateur.observe(blocReservation);
    }

    // ----------------------------------------------------------------
    // 6. Interaction avec le calendrier : mesuree par le widget lui-meme
    // ----------------------------------------------------------------
    // Rien ici, et c'est volontaire. widget_interact a ete supprime le
    // 11/09/2026 : voir l'en-tete du fichier. assets/loven-booking.js emet
    // calendar_open des que le visiteur ouvre le calendrier, ce qui est la
    // meme information mesuree a la source plutot que devinee.

    // ----------------------------------------------------------------
    // 7. Messages envoyes par le widget Bookingmood
    // ----------------------------------------------------------------
    // Aujourd'hui le widget n'emet qu'un message de redimensionnement
    // (context iframe.resize). Un changement de hauteur significatif indique
    // que le contenu du calendrier s'est deploye, donc que le visiteur a agi :
    // c'est un signal secondaire d'interaction, heuristique et a recalibrer.
    // Le payload conserve aussi le delta de hauteur pour affiner le seuil.
    // Ce bloc est aussi le point de branchement pret a recevoir de vrais
    // evenements de calendrier si Bookingmood venait a les exposer.
    window.addEventListener('message', function (evenement) {
      var origine = evenement.origin;
      if (origine !== 'https://bookingmood.com' && origine !== 'https://www.bookingmood.com') {
        return;
      }

      var donnees = evenement.data;
      if (typeof donnees === 'string') {
        try {
          donnees = JSON.parse(donnees);
        } catch (e) {
          return;
        }
      }
      if (!donnees || typeof donnees !== 'object') return;

      var contexteMessage = donnees.context || donnees.type || '';

      if (contexteMessage === 'iframe.resize') {
        // Ce message ne sert plus a rien : il n'alimentait que widget_interact,
        // supprime le 11/09/2026. Il n'arrive de toute facon que sur le repli
        // iframe, qui ne se monte qu'en cas d'echec du widget v2. Ignore.
        return;
      }

      // ---- Point de branchement SCENARIO A : INACTIF a ce jour ----
      // Bookingmood n'emet aucun de ces trois messages (verifie par sonde).
      // Le code est conserve tel quel pour s'activer sans redeploiement le
      // jour ou Bookingmood exposerait ces evenements. Tant que ce n'est pas
      // le cas, date_selected, no_availability et checkout_start restent a zero.
      if (contexteMessage === 'booking.date_selected') {
        envoyer('date_selected', { dates: donnees.dates || null });
      } else if (contexteMessage === 'booking.no_availability') {
        envoyer('no_availability', {});
      } else if (contexteMessage === 'booking.checkout_start') {
        envoyer('checkout_start', {}, { immediat: true });
      }
      // Tout autre message est ignore sans erreur.
    });

    // ----------------------------------------------------------------
    // 8. Contact direct et sorties de page
    // ----------------------------------------------------------------
    // Objectif : mesurer une FUITE hors commission, c'est a dire un visiteur
    // qui quitte le parcours pour joindre l'hebergeur en direct.
    // Contre exemple a exclure absolument : le partage social ou par mail,
    // qui est au contraire le comportement le plus engage de la page. La fiche
    // produit contient un lien mailto sans destinataire (partage), ainsi que
    // des liens vers wa.me, facebook, instagram, tiktok, judge.me et
    // openstreetmap. Les compter comme fuite inverserait completement le signal.

    // Domaines neutres : trafic sortant normal d'une fiche produit, jamais
    // une fuite de commission. Compare sur le domaine et ses sous domaines.
    //
    // INTERDICTION ABSOLUE : ne jamais ajouter ici une plateforme de
    // reservation concurrente. Nommement, et sans que la liste soit limitative :
    //   airbnb.fr, airbnb.com, booking.com, abritel.fr, gitesdefrance.com,
    //   leboncoin.fr, expedia.fr
    // Un clic vers l'une d'elles est par definition une fuite de commission :
    // c'est exactement ce que contact_direct doit capter. Le metafield
    // accentuate.url porte d'ailleurs une annonce Airbnb sur certaines fiches
    // (non rendue dans le HTML public a ce jour, mais elle peut l'etre demain),
    // de meme que accentuate.telephone et accentuate.email. Voir du trafic
    // sortant vers ces domaines n'est pas un faux positif a blanchir, c'est
    // le signal.
    var DOMAINES_NEUTRES = [
      'facebook.com',
      'instagram.com',
      'tiktok.com',
      'wa.me',
      'whatsapp.com',
      'x.com',
      'twitter.com',
      'pinterest.com',
      'pinterest.fr',
      'linkedin.com',
      'youtube.com',
      'openstreetmap.org',
      'judge.me',
      'shopify.com',
      'shopifycdn.com',
      'unpkg.com',
      'leafletjs.com',
      'google.com',
      'gstatic.com'
    ];

    function estNeutre(domaine) {
      if (!domaine) return true;
      var d = domaine.toLowerCase();
      for (var i = 0; i < DOMAINES_NEUTRES.length; i++) {
        var n = DOMAINES_NEUTRES[i];
        if (d === n || d.slice(-(n.length + 1)) === '.' + n) return true;
      }
      // pinterest.* et autres declinaisons pays.
      if (d === 'pinterest' || d.indexOf('pinterest.') === 0 || d.indexOf('.pinterest.') !== -1) return true;
      return false;
    }

    // Un mailto de partage n'a pas de destinataire, ou porte subject / body.
    function estMailtoDePartage(href) {
      var reste = href.slice('mailto:'.length);
      var separateur = reste.indexOf('?');
      var destinataire = (separateur === -1 ? reste : reste.slice(0, separateur)).trim();
      if (!destinataire) return true;
      var query = separateur === -1 ? '' : reste.slice(separateur + 1).toLowerCase();
      if (query.indexOf('subject=') !== -1 || query.indexOf('body=') !== -1) return true;
      return false;
    }

    // Delegation d'evenement sur document : un seul ecouteur pour tous les liens.
    document.addEventListener('click', function (evenement) {
      var element = evenement.target;
      while (element && element.tagName !== 'A') {
        element = element.parentElement;
      }
      if (!element) return;

      var href = element.getAttribute('href') || '';
      if (!href) return;

      if (href.indexOf('tel:') === 0) {
        // Un tel: n'a de sens que pour appeler quelqu'un : toujours une fuite.
        if (href.slice(4).trim()) {
          envoyer('contact_direct', { canal: 'telephone', domaine: null });
        }
        return;
      }

      if (href.indexOf('mailto:') === 0) {
        if (estMailtoDePartage(href)) return; // Partage, pas contact.
        envoyer('contact_direct', { canal: 'email', domaine: null });
        return;
      }

      var domaine = domaineDe(element.href);
      if (!domaine || domaine === window.location.hostname) return;

      // ---- Point de branchement SCENARIO A : INACTIF a ce jour ----
      // Verifie le 2 septembre 2026 sur la fiche pilote : la page parente ne
      // contient aucun lien vers bookingmood.com. Le bouton Reserver maintenant
      // vit dans l'iframe cross-origin, son clic ne remonte jamais au document
      // parent. Cette branche ne se declenchera que si le theme pose un jour un
      // lien sortant direct vers Bookingmood.
      if (domaine.indexOf('bookingmood.com') !== -1) {
        envoyer('checkout_start', { domaine: domaine }, { immediat: true });
        return;
      }

      // Reseaux sociaux, cartographie, avis, CDN : trafic normal, pas une fuite.
      if (estNeutre(domaine)) return;

      // Reste : domaine externe non identifie, potentielle fuite hors commission.
      // Le domaine est toujours consigne pour recalibrer la liste blanche.
      envoyer('contact_direct', { canal: 'lien_sortant', domaine: domaine });
    }, true);

    // ----------------------------------------------------------------
    // 8bis. Revelation des coordonnees hebergeur
    // ----------------------------------------------------------------
    // Le theme n'expose JAMAIS le telephone ni l'URL du site en clair : le
    // snippet loven-contact-reveal.liquid encode la valeur en base64 inverse
    // cote serveur et rend un simple bouton :
    //   <button data-loven-reveal="phone|url" data-loven-payload="...">
    // C'est un dispositif anti-scraping. La delegation de la section 8, qui
    // cherche a[href^="tel:"] et les liens sortants, ne capte donc rien au
    // chargement de la page : il n'y a aucun lien, seulement des boutons.
    //
    // On ecoute ici les boutons eux-memes. C'est un signal d'intention plus
    // net qu'un clic sur un lien : personne ne clique sur "Voir le numero"
    // par accident, alors qu'un tel: peut etre un clic parasite sur mobile.
    //
    // Funnel de fuite a deux etages pour le telephone :
    //   contact_reveal canal telephone = je veux le numero ;
    //   contact_direct canal telephone = j'appelle vraiment. Capte par la
    //   section 8 sans rien ajouter, car loven-contact-reveal.js remplace le
    //   bouton par un vrai <a href="tel:...">.
    // Pour le site il n'y a qu'un etage : loven-contact-reveal.js fait un
    // window.open() sans jamais ecrire l'URL dans le DOM, donc aucun clic sur
    // un lien n'existera jamais. contact_direct ne se produira pas dans ce cas.
    //
    // RGPD : on n'envoie QUE le canal, jamais la valeur. Le payload du bouton
    // est decodable, mais le decoder ici reviendrait a transmettre le numero
    // ou l'URL de l'hebergeur, qui sont des donnees personnelles. L'identite
    // de l'hebergement est deja portee cote serveur par hebergement_id.
    //
    // Ecouteur independant de loven-contact-reveal.js : les deux delegations
    // coexistent sans se gener. Ne jamais ajouter l'appel de tracking dans
    // loven-contact-reveal.js, cela couplerait l'anti-scraping a la mesure
    // d'audience et la prochaine mise a jour de l'un casserait l'autre.
    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target;
      while (bouton && !(bouton.getAttribute && bouton.getAttribute('data-loven-reveal'))) {
        bouton = bouton.parentElement;
      }
      if (!bouton) return;

      var kind = bouton.getAttribute('data-loven-reveal');
      var canal = kind === 'phone' ? 'telephone' : (kind === 'url' ? 'site' : null);
      if (!canal) return;

      envoyer('contact_reveal', { canal: canal }, { uneSeuleFois: true });
    }, true);

    // ----------------------------------------------------------------
    // 9. Depart de la page
    // ----------------------------------------------------------------
    var scrollMaximum = 0;

    function mesurerScroll() {
      var hauteurDocument = Math.max(
        document.body ? document.body.scrollHeight : 0,
        document.documentElement ? document.documentElement.scrollHeight : 0
      );
      if (hauteurDocument <= 0) return;
      var position = (window.scrollY || window.pageYOffset || 0) + window.innerHeight;
      var pourcentage = Math.round((position / hauteurDocument) * 100);
      if (pourcentage > scrollMaximum) {
        scrollMaximum = Math.min(pourcentage, 100);
      }
    }

    window.addEventListener('scroll', mesurerScroll, { passive: true });
    mesurerScroll();

    var sortieEnvoyee = false;

    document.addEventListener('visibilitychange', function () {
      if (sansFiche) return;
      if (document.visibilityState !== 'hidden' || sortieEnvoyee) return;
      sortieEnvoyee = true;
      envoyer(
        'fiche_exit',
        {
          duree_s: Math.round((Date.now() - debutVisite) / 1000),
          scroll_pct: scrollMaximum
        },
        { immediat: true, beacon: true }
      );
    });

    // Depart de page : vide toute la file par beacon, a chaque masquage et
    // sur pagehide (navigation, fermeture, mise en cache bfcache). Sans cela,
    // un evenement mis en file (minuteur de 5 s) juste avant une navigation,
    // ou apres un premier retour sur l'onglet, est perdu. Correctif 01/10/2026.
    function viderAuDepart() {
      if (minuteur) {
        window.clearTimeout(minuteur);
        minuteur = null;
      }
      vider(true);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') viderAuDepart();
    });
    window.addEventListener('pagehide', viderAuDepart);
  } catch (erreur) {
    // Le tracker ne doit jamais casser la page ni afficher d'erreur.
  }
})();

/*
  ----------------------------------------------------------------------
  REQUETES DE CONTROLE (a executer en base apres 48 h de collecte)
  ----------------------------------------------------------------------

  1. SONDE DE SURVIE de widget_visible, a relancer apres toute refonte du
     bloc de reservation. Si une variante tombe a zero alors que les fiches
     correspondantes recoivent toujours des fiche_view, le selecteur
     .loven-dates a ete casse : c'est exactement la panne du 08/09/2026,
     qui est restee invisible trois jours.

     select payload->>'variante' as variante, count(*) as evenements,
            count(distinct session_id) as sessions, max(occurred_at) as dernier
     from funnel_events
     where event_type = 'widget_visible'
       and occurred_at > now() - interval '7 days'
     group by 1 order by evenements desc;

  2. Taux de passage du bloc vu au calendrier ouvert, par variante.
     Une variante 'external' n'a pas de calendar_open : c'est normal, son
     issue mesurable est outbound_booking_click.

     select v.payload->>'variante' as variante,
            count(distinct v.session_id) as blocs_vus,
            count(distinct c.session_id) as calendriers_ouverts
     from funnel_events v
     left join funnel_events c
       on c.session_id = v.session_id and c.event_type = 'calendar_open'
     where v.event_type = 'widget_visible'
       and v.occurred_at > now() - interval '7 days'
     group by 1 order by blocs_vus desc;

  3bis. Funnel de fuite a deux etages sur le telephone.
     Beaucoup de revelations sans appel = verification de confiance, le
     visiteur veut s'assurer qu'il y a un humain derriere l'annonce ; ce n'est
     pas une fuite mais un besoin de reassurance a traiter sur la fiche.
     Un taux d'appel eleve apres revelation = fuite reelle hors commission.

     select
       count(distinct session_id) filter (
         where event_type = 'contact_reveal' and payload->>'canal' = 'telephone'
       ) as revelations_tel,
       count(distinct session_id) filter (
         where event_type = 'contact_direct' and payload->>'canal' = 'telephone'
       ) as appels_reels,
       count(distinct session_id) filter (
         where event_type = 'contact_reveal' and payload->>'canal' = 'site'
       ) as revelations_site
     from funnel_events
     where occurred_at > now() - interval '7 days';

  3. Domaines vus en contact_direct, pour recalibrer la liste blanche.

     select payload->>'canal' as canal,
            coalesce(payload->>'domaine', '(sans domaine)') as domaine,
            count(*) as evenements
     from funnel_events
     where event_type = 'contact_direct'
       and occurred_at > now() - interval '7 days'
     group by 1, 2 order by evenements desc;

  4. Evenements non resolus (compteur d'appariement catalogue).

     select date_trunc('day', occurred_at) as jour,
            count(*) filter (where hebergement_id is null) as non_resolus,
            count(*) as total
     from funnel_events
     where occurred_at > now() - interval '7 days'
     group by 1 order by 1;

  5. Sessions ayant depasse 250 evenements sur 7 jours.
     Un compteur non nul indique un parcours anormal ou un abus ; il justifie
     de ne pas remonter le plafond sans diagnostic.

     select count(distinct session_id) as sessions_saturees
     from (
       select session_id from funnel_events
       where occurred_at > now() - interval '7 days'
       group by session_id having count(*) > 250
     ) s;
*/
